import {
  absolute,
  colors,
  FlexRow,
  font,
  fontSizes,
  marginHorizontal,
  padding,
} from '@toilet-paper-games/ui';
import { Link2Icon } from 'lucide-react';
import { URLs } from '../utils/url';

export const FooterInfo = () => {
  return (
    <footer
      css={[
        absolute(undefined, 0, 0, 0),
        padding('md'),
        font('sans-serif', fontSizes.sm),
        {
          color: colors.border,
          textAlign: 'center',
          a: {
            color: 'inherit',
            cursor: 'pointer',
            textDecoration: 'underline',
          },
          '@media (max-width: 768px)': {
            display: 'none',
          },
        },
      ]}
    >
      <FlexRow justifyContent="space-between">
        <span>
          TP Games © {new Date().getFullYear()}
          <a href={URLs.blog} target="_blank" css={marginHorizontal('lg')}>
            blog
            <Link2Icon css={{ height: 10 }} />
          </a>
        </span>
        <span css={marginHorizontal('xxl')}>
          <a href={URLs.termsAndConditions} target="_blank" css={marginHorizontal('lg')}>
            terms & conditions
            <Link2Icon css={{ height: 10 }} />
          </a>
          <a href={URLs.privacyPolicy} target="_blank" css={marginHorizontal('lg')}>
            privacy policy
            <Link2Icon css={{ height: 10 }} />
          </a>
        </span>
      </FlexRow>
    </footer>
  );
};
